<template>
    <v-container fluid class="footer01">
        <div class="icon" :class="this.$router.currentRoute.name == 'Todo' ? 'active' : ''" @click="goTo('Todo')">
            <i class="mdi mdi-format-list-numbered"></i>
            <div class="countLead" v-if="todoCount > 0">{{todoCount}}</div>
        </div>
        <div class="icon" :class="this.$router.currentRoute.name == 'Leads' ? 'active' : ''" @click="goTo('Leads')">
            <i class="mdi mdi-account-multiple"></i>
        </div>
        <div class="icon" :class="this.$router.currentRoute.name == 'Rdv' ? 'active' : ''" @click="goTo('Rdv')">
            <i class="mdi mdi-calendar"></i>
        </div>
        <div class="icon" :class="this.$router.currentRoute.name == 'Medias' ? 'active' : ''" @click="goTo('Medias')">
            <i class="mdi mdi-video"></i>
        </div>
        <div class="icon" :class="this.$router.currentRoute.name == 'Statistique' ? 'active' : ''" @click="goTo('Statistique')">
            <i class="mdi mdi-chart-bar"></i>
        </div>     
    </v-container>
</template>
<script>
export default {
    props: ['code'],
    methods: {
        goTo(routeName) {
            if(this.$router.history.current.name != routeName){
                this.$store.dispatch('setLoader', true)
                this.$router.push({ name: routeName, params: { code: this.code } })
            }
        }
    },
    computed: {
        todoCount: function(){
            const leads = this.$store.getters.leadsTodo
            return leads.length
        },
    },
}
</script>
<style lang="scss">
    .footer01 {
        padding:0;
        height:8vh;
        position:fixed;
        bottom:0;
        display:flex;
        align-items:center;
        justify-content: space-around;
        background-color: white;
        z-index:4;
        border-top:2px solid #eb566b;
        .icon {
            height:100%;
            width:20vw;
            display:flex;
            position:relative;
            align-items: center;
            justify-content: center;
            i {
                color:#eb566b;
                font-size:1.6em;
                font-weight:400;
            }
            &.active {
                background-color: #ffd9de;
               
            }
            .countLead {
                position:absolute;
                bottom:10px;
                right:10px;
                font-size:14px;
                font-weight:bold;
                background-color:#eb566b;
                width:18px;
                height:18px;
                border-radius:50%;
                display:flex;
                align-items: center;
                justify-content: center;
                color:white;
            }
        }
        
    }
</style>